import { render, staticRenderFns } from "./WaterMonitoring.vue?vue&type=template&id=57472f41&scoped=true&"
import script from "./WaterMonitoring.vue?vue&type=script&lang=js&"
export * from "./WaterMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./WaterMonitoring.vue?vue&type=style&index=0&id=57472f41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57472f41",
  null
  
)

export default component.exports